import {
  ChannelsState,
  UserState,
  initialChannelsState,
  initialUserState,
} from '@nx/bidding-engine'

export type AppStoreState = UserState & ChannelsState

export const appDefaultState: AppStoreState = {
  ...initialChannelsState,
  ...initialUserState,
}
